import React from 'react';
import { Row, Col } from 'react-bootstrap';

import FieldSelectDriveability from './FieldSelectDriveability.jsx';
import FieldSelectTrackCondition from './FieldSelectTrackCondition.jsx';
import FieldSelectWeatherCondition from './FieldSelectWeatherCondition.jsx';
import FieldTextArea from './FieldTextArea.jsx';
import FieldTextBox from './FieldTextBox.jsx';

export default function QualifyingDetails() {
  return (
    <div id="section-qualify-details">
      <h4 className="rating-type">Qualifying</h4>

      <Row>
        <Col sm={3} xs={12}>
          <FieldTextBox placeholder="Time (e.g. 12:00PM)" field="timeOfDay" />
        </Col>
        <Col sm={3} xs={12}>
          <FieldTextBox placeholder="Laps Completed" field="approxLapsCompleted" />
        </Col>
        <Col sm={3} xs={12}>
          <FieldTextBox placeholder="Qualifying Position" field="qualifyPosition" />
        </Col>
        <Col sm={3} xs={12}>
          <FieldTextBox placeholder="Expected Race Finish Position" field="expectedRacePosition" />
        </Col>
      </Row>
      <Row>
        <Col sm={6} xs={12}>
          <FieldSelectWeatherCondition defaultEmptyOption="Weather Condition" />
        </Col>
        <Col sm={6} xs={12}>
          <FieldTextBox placeholder="Temperature" field="weatherTemperature" />
        </Col>
      </Row>
      <Row>
        <Col sm={6} xs={12}>
          <FieldSelectTrackCondition defaultEmptyOption="Track Condition" />
        </Col>
        <Col sm={6} xs={12}>
          <FieldSelectDriveability defaultEmptyOption="Track Driveability" />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <FieldTextArea placeholder="Track Notes" field="trackComments" />
        </Col>
        <Col xs={12}>
          <FieldTextArea placeholder="Qualifying Notes" field="qualifyNotes" />
        </Col>
      </Row>
    </div>
  );
}
